import { CHART_CONST_INFO } from '../../constants/common/chart/chartConst';

export const barChartOptions = (hTitle: string, chartColors: string[], chartType: string, chartWith: any[]): {} => {
    let linkStyle = {}
    if ([CHART_CONST_INFO.ACTIVATE_WORKGROUP_BY_DUEDATE,
    CHART_CONST_INFO.ACTIVATE_WORKGROUP_BY_STATUS,
    CHART_CONST_INFO.ACTIVATE_WORKGROUP_BY_DUEDATE_RESOLVED_TODAY,
    CHART_CONST_INFO.RESOLVED_DATE_REPORTS_GROUP_BY_ASSIGNEE].includes(chartType)) {
        linkStyle = {
            cursor: "pointer",
            color: "#3435A7",
            underline: true,
            linkSuggested: true
        }
    }
    const width = Number(chartWith.length || 15) > 20 ? 1800 : 'auto';
    const chartDataArray =  chartWith.map(v=>v.filter(v=>!isNaN(v))).map(v=>v.filter(v=> v>0)).filter(v=>v.length>0);
    const tickValue = chartDataArray?.length || 0;
    
    return {
        width, 
        titleTextStyle: {
            fontSize: 15,
            bold: true,
            left: 10
        },
        chartArea: {
            top: 50,
            bottom: 100,
            right: 100,
            left: 150
        },
        colors: chartColors,
        bar: { groupWidth: '90%' },
        legend: "none",
        chart: {
            textStyle: {
                fontSize: 13,
                bold: true,
            },
        },
        vAxis: {
            title: hTitle,
            titleTextStyle: { italic: false,  bold: true },
            minValue: 0,
            ticks: !tickValue ?  [0, 1, 2] : null,
            textStyle: {
                fontSize: 13,
            },
            format:''
        },
        hAxis: {
            textPosition: 'out',
            titleTextStyle: { italic: false,  bold: true},
            minValue: 0,
            textStyle: {
                fontSize: 13,
                ...linkStyle
            },
            slantedText: true
        },
        axes: {
            y: {
                0: { side: 'right' },
            },
        },
    };
}